import { AxiosResponse } from "axios";
import { BASE_URL, DOCUMENT, USER } from "../constants/mainAPI";
import { UserFilesSuccessResponse } from "../types/api/getFile";
import { ErrorResponseType } from "../types/api/main";
import { doGetRequest, doPostRequest } from "./mainAPI";

const getWithBody = (
    path: string,
    body: any,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
): Promise<AxiosResponse<any>> => {
    const url = new URL(path, BASE_URL).toString();
    return fetch(url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    })
        .then(response => response.json())
        .then((response: any) => response.data)
        .catch((err: any) => (errorCallback ? errorCallback(err.response.data) : Promise.reject(err.response.data)));
};

export const getUserFile = (
    format: number | undefined,
    callback?: (resp: UserFilesSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doGetRequest(`${USER}/${DOCUMENT}`, true, { per_page: -1 }, callback, errorCallback);
};
